import React from 'react';
import styles from '../../styles/BecasStyles/Becas.module.css';

function ViewBecaModal({ isOpen, onClose, beca }) {
  if (!isOpen || !beca) return null;

  // Convertir fecha ISO a formato DD/MM/YYYY
  const formatDate = (isoDate) => {
    if (!isoDate) return '-';
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Función para limpiar el marcador de secciones de la descripción
  const cleanDescripcion = (descripcion) => {
    if (!descripcion) return '-';
    // Remover el marcador [SECCIONES:...] de la descripción
    const regex = /\s*\[SECCIONES:[^\]]*\]\s*/g;
    const cleaned = descripcion.replace(regex, '').trim();
    return cleaned || '-';
  };

  return (
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div className={styles.viewBecaModalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.viewBecaModalHeader}>
          <h2 className={styles.viewBecaModalTitle}>Ver Beca</h2>
        </div>

        <div className={styles.viewBecaModalBody}>
          <div className={styles.viewBecaFormGrid}>
            {/* Primera fila */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Nombre de beca</label>
              <div className={styles.readOnlyField}>{beca.nombre || '-'}</div>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Código de beca</label>
              <div className={styles.readOnlyField}>{beca.codigo || '-'}</div>
            </div>

            {/* Segunda fila */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Tipo de beca</label>
              <div className={styles.readOnlyField}>{beca.tipo_de_beca || '-'}</div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Estado</label>
              <div className={styles.readOnlyField}>{beca.estado || '-'}</div>
            </div>

            {/* Descripción - ancho completo */}
            <div className={`${styles.formGroup} ${styles.fullWidth}`}>
              <label className={styles.formLabel}>Descripción</label>
              <div className={styles.readOnlyField}>{cleanDescripcion(beca.descripcion)}</div>
            </div>

            {/* Tercera fila */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Porcentaje máximo de beca (%)</label>
              <div className={styles.readOnlyField}>
                {beca.porcentaje_maximo ? `${beca.porcentaje_maximo}%` : '-'}
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Monto máximo</label>
              <div className={styles.readOnlyField}>
                {beca.monto_maximo ? `$${parseFloat(beca.monto_maximo).toLocaleString('es-MX', { minimumFractionDigits: 2 })}` : '-'}
              </div>
            </div>

            {/* Secciones aplicables */}
            <div className={`${styles.formGroup} ${styles.fullWidth}`}>
              <label className={styles.formLabel}>Secciones aplicables</label>
              <div className={styles.readOnlyField}>
                {beca.secciones_aplicables && beca.secciones_aplicables.length > 0 
                  ? beca.secciones_aplicables.join(', ') 
                  : '-'}
              </div>
            </div>

            {/* Requisitos - ancho completo */}
            <div className={`${styles.formGroup} ${styles.fullWidth}`}>
              <label className={styles.formLabel}>Requisitos</label>
              <div className={styles.readOnlyField}>{beca.requisitos || '-'}</div>
            </div>

            {/* Campus */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Campus</label>
              <div className={styles.readOnlyField}>{beca.campus_nombre || '-'}</div>
            </div>

            {/* Fondo asignado */}
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Fondo asignado</label>
              <div className={styles.readOnlyField}>
                {beca.fondo_asignado ? `$${parseFloat(beca.fondo_asignado).toLocaleString('es-MX', { minimumFractionDigits: 2 })}` : '-'}
              </div>
            </div>

            {/* Institución */}
            <div className={`${styles.formGroup} ${styles.fullWidth}`}>
              <label className={styles.formLabel}>Institución</label>
              <div className={styles.readOnlyField}>{beca.institucion_nombre || '-'}</div>
            </div>
          </div>
        </div>

        <div className={styles.viewBecaModalActions}>
          <button className={styles.cancelarButton} onClick={onClose}>
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewBecaModal;
